const IS_DEV = process.env.VUE_APP_DEV
const VERSION = process.env.VUE_APP_VERSION

export default {
    data(): any {
        return {}
    },

    methods: {
        addTimestampToURL(url) {
            const timestamp = new Date().getTime()

            const v = parseInt(IS_DEV) ? timestamp : VERSION

            return `${url}`
        },
    },
}
